import { useContext } from "react"
import { Box, alpha } from '@mui/material'
import { customColor, customColorType } from "src/theme/custom.types"
import { CustomThemeContext } from "src/theme/ThemeProvider"

const ThemeChoose = (): JSX.Element => {
    const themeContext = useContext(CustomThemeContext)
    
    const colors: Array<{ key: customColorType, color: string, name: string }> = [
        { key: 'blue', color: customColor.blue, name: 'Blue' },
        { key: 'orange', color: customColor.orange, name: 'Orange' },
        { key: 'yellow', color: customColor.yellow, name: 'Yellow' },
        { key: 'green', color: customColor.green, name: 'Green' },
        { key: 'berry', color: customColor.berry, name: 'Berry' },
        { key: 'pink', color: customColor.pink, name: 'Pink' },
        { key: 'red', color: customColor.red, name: 'Red' }
    ]
    
    return (
        <Box sx={{ 
            display: 'flex',
            background: (theme) => alpha(theme.palette.divider, 0.08),
            borderRadius: '12px',
            padding: '2px',
            gap: '1px'
        }}>
            {colors.map((colorOption) => (
                <Box
                    key={colorOption.key}
                    onClick={() => themeContext.setColor(colorOption.key)}
                    sx={{
                        padding: '2px 3px',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        fontSize: '0.55rem',
                        fontWeight: 500,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.3,
                        minWidth: '28px',
                        justifyContent: 'center',
                        background: themeContext.color === colorOption.key 
                            ? colorOption.color
                            : 'transparent',
                        color: themeContext.color === colorOption.key 
                            ? 'white' 
                            : (theme) => theme.palette.text.secondary,
                        '&:hover': {
                            background: themeContext.color === colorOption.key 
                                ? colorOption.color
                                : (theme) => alpha(colorOption.color, 0.1)
                        }
                    }}
                >
                    <Box
                        sx={{
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            backgroundColor: colorOption.color,
                            opacity: themeContext.color === colorOption.key ? 0.8 : 1
                        }}
                    />
                    {colorOption.name.charAt(0)}
                </Box>
            ))}
        </Box>
    )
}
export default ThemeChoose;